import React from 'react';
import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useRoutes from '../../../hooks/useRoutes';
import Loader from '../../../components/Loader';
import CustomRoute from '../CustomRoute';
import type { CustomRouteProps } from '../types';

const PrivateRoute: React.FC<CustomRouteProps> = ({ search, children, ...props }) => {
  const { login } = useRoutes();
  const isLoggedIn = useSelector<ImmutableRootState<boolean>, boolean>((state) => state.getIn(['login', 'loggedIn'], null));

  return (
    <CustomRoute
      {...props}
      render={(routeProps) => {
        switch (isLoggedIn) {
          case true: {
            if (typeof children === 'function') {
              return children(routeProps);
            }

            return children;
          }

          case false:
            return (
              <Redirect
                to={{
                  pathname: login,
                  state: { from: routeProps.location },
                  search,
                }}
              />
            );

          default:
            return <Loader />;
        }
      }}
    />
  );
};

export default PrivateRoute;
